/** @format */

document.addEventListener("DOMContentLoaded", function () {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach((link) => {
    link.addEventListener("click", handleAnchorClick);
  });

  const externalAnchorLinks = document.querySelectorAll(
    'a[href*="#"]:not([href^="#"])'
  );

  externalAnchorLinks.forEach((link) => {
    link.addEventListener("click", handleExternalAnchorClick);
  });

  if (window.location.hash) {
    setTimeout(function () {
      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const offsetTop =
          window.innerWidth > 867 ? 56 : window.innerWidth > 798 ? 128 : 40;
        const targetPosition =
          targetElement.getBoundingClientRect().top +
          window.pageYOffset -
          offsetTop;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    }, 300);
  }

  const resizeHandler = handleResize;
  window.addEventListener("resize", resizeHandler);

  window.addEventListener("beforeunload", function () {
    window.removeEventListener("resize", resizeHandler);

    anchorLinks.forEach((link) => {
      link.removeEventListener("click", handleAnchorClick);
    });

    externalAnchorLinks.forEach((link) => {
      link.removeEventListener("click", handleExternalAnchorClick);
    });
  });

  window.cleanupAnchorScroll = function () {
    window.removeEventListener("resize", resizeHandler);

    anchorLinks.forEach((link) => {
      link.removeEventListener("click", handleAnchorClick);
    });

    externalAnchorLinks.forEach((link) => {
      link.removeEventListener("click", handleExternalAnchorClick);
    });
  };
});

function handleAnchorClick(e) {
  e.preventDefault();

  const targetId = this.getAttribute("href").substring(1);
  const targetElement = document.getElementById(targetId);
  if (!targetElement) return;

  const offsetTop =
    window.innerWidth > 867 ? 56 : window.innerWidth > 798 ? 128 : 40;
  const targetPosition =
    targetElement.getBoundingClientRect().top + window.pageYOffset - offsetTop;

  window.scrollTo({
    top: targetPosition,
    behavior: "smooth",
  });
}

function handleExternalAnchorClick(e) {
  const href = this.getAttribute("href");
  const currentDomain = window.location.hostname;
  const linkUrl = new URL(href, window.location.href);

  if (linkUrl.hostname === currentDomain) {
    const samePage = linkUrl.pathname === window.location.pathname;

    if (samePage && linkUrl.hash) {
      e.preventDefault();

      const targetId = linkUrl.hash.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const offsetTop =
          window.innerWidth > 867 ? 56 : window.innerWidth > 798 ? 128 : 40;
        const targetPosition =
          targetElement.getBoundingClientRect().top +
          window.pageYOffset -
          offsetTop;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    }
  }
}

function handleResize() {
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const offsetTop =
        window.innerWidth > 867 ? 56 : window.innerWidth > 798 ? 128 : 40;
      const targetPosition =
        targetElement.getBoundingClientRect().top +
        window.pageYOffset -
        offsetTop;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  }
}
